export interface TerrainType {
  id: string;
  name: string;
  description: string;
  color: number; // PIXI.js color in hexadecimal
  passable: boolean;
  resourceYield?: { [key: string]: number }; // Optional: resources this terrain might provide
}

export const TERRAIN_TYPES: TerrainType[] = [
  {
    id: 'grassland',
    name: 'Grassland',
    description: 'Open, grassy areas suitable for agriculture and grazing.',
    color: 0x7CFC00, // Light green
    passable: true,
    resourceYield: { nutriment: 3, gossamer: 1 },
  },
  {
    id: 'forest',
    name: 'Forest',
    description: 'Dense wooded areas rich in natural resources.',
    color: 0x228B22, // Forest green
    passable: true,
    resourceYield: { gossamer: 3, nutriment: 1, dynamis: 1 },
  },
  {
    id: 'hills',
    name: 'Hills',
    description: 'Elevated terrain with varied vegetation and mineral deposits.',
    color: 0x8B4513, // Saddle brown
    passable: true,
    resourceYield: { ferron: 2, lux: 1 },
  },
  {
    id: 'mountains',
    name: 'Mountains',
    description: 'High, rocky terrain rich in minerals and crystals.',
    color: 0x808080, // Gray
    passable: false,
    resourceYield: { ferron: 3, lux: 2 },
  },
  {
    id: 'water',
    name: 'Water',
    description: 'Lakes, rivers, and other bodies of water.',
    color: 0x1E90FF, // Dodger blue
    passable: false,
    resourceYield: { hydor: 3 },
  },
  // Add more terrain types as needed
];
export const getTerrainById = (id: string): TerrainType | undefined => 
  TERRAIN_TYPES.find(terrain => terrain.id === id);
